import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { Utility } from 'Services';

// Images
import Logo from 'Assets/images/logo.png';

export default (props) => {
  const [profileIcons, setProfileIcons] = useState([]);

  useEffect(() => {
    const getProfileIcons = async () => {
      try {
        const { profileDefaultIcons } = await Utility.getProfileIcons();
        setProfileIcons(profileDefaultIcons);
      } catch (error) {
        console.error('Error', error);
      }
    };

    getProfileIcons();
  }, []);

  const handleImageClick = (imgUrl) => {
    props.setUpdatedProfile(imgUrl);
    props.onHide();
  };

  return (
    <Modal {...props} size="md" centered className="strategy-icons-modal" animation={false}>
      <Modal.Header closeButton>
        <Modal.Title />
      </Modal.Header>
      <Modal.Body>
        <div>
          <img src={Logo} alt="logo" className="logo" />
        </div>
        <div className="mt-2">
          <p className="color-white">Please select profile</p>
          <div className="icons">
            {profileIcons.map((imgUrl) => (
              <div key={imgUrl} className="m-2 cursor-pointer">
                <img src={imgUrl} alt="icon" height={60} width={60} onClick={() => handleImageClick(imgUrl)} />
              </div>
            ))}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
